import { BasicDataFormSelector } from "./components/BasicDataFormSelector";
import { Header } from "src/apps/components/header/Header";
import { BaseScreen } from "../../components/baseScreen/BaseScreen";

import { CenteredContainer } from "./components/CenteredContainer";
import { colors } from "@permisso/permisso-components";

export const BasicDataScreen = () => {
  return (
    <BaseScreen
      backgroundColor={colors.grey0}
      header={<Header />}
      screenPadding="32px"
      mobileScreenPadding="20px"
    >
      <CenteredContainer>
        <BasicDataFormSelector />
      </CenteredContainer>
    </BaseScreen>
  );
};
